var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"color":"primary","size":_vm.size}},[(_vm.avatar)?_c('v-img',{attrs:{"src":_vm.avatar}}):_c('v-icon',{attrs:{"dark":"","size":_vm.size * 0.7}},[_vm._v(" mdi-account ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }